import { render } from "./BatteryComponent.vue?vue&type=template&id=79011c9f&scoped=true"
import script from "./BatteryComponent.vue?vue&type=script&lang=js"
export * from "./BatteryComponent.vue?vue&type=script&lang=js"

import "./BatteryComponent.vue?vue&type=style&index=0&id=79011c9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79011c9f"]])

export default __exports__